import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { CLAIMS_UPDATESTATUS_INIT_LOADING, CLAIMS_UPDATESTATUS_INIT_SUCCESS, CLAIMS_UPDATESTATUS_INIT_FAIL } from '@/store/types'

export const updateStatus = {
  async claimUpdateStatusInit({ commit, state }) {
    if (state.updateStatus.init !== 1) {
      const apiUrl = state.menu.updateStatus
      if (apiUrl) {
        commit(CLAIMS_UPDATESTATUS_INIT_LOADING)
        try {
          const result = await http.get(apiUrl)
          if (result.data) {
            const { data } = result.data
            if (data) {
              const menu = extractMenu(result.data._links)
              const commitResult = {
                menu: menu,
                statusList: data.statusList
              }
              commit(CLAIMS_UPDATESTATUS_INIT_SUCCESS, commitResult)
            }
          }
        } catch (error) {
          commit(CLAIMS_UPDATESTATUS_INIT_FAIL, extractMessages(error))
        }
      } else {
        commit(CLAIMS_UPDATESTATUS_INIT_FAIL, ['Invalid API URL'])
      }
    }
  }
}
